import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../../../Form'
import {
  RentalPortalListingDepositAmountField,
  RentalPortalListingDepositTextField,
  RentalPortalListingRentPriceField,
  RentalPortalListingServiceChargeField,
} from '../../../../../../../RentalPortalListing'
import { useRentalPortalProfileBlockFormActions } from '../../../../../../RentalPortal.hooks'

import { HeatingCostsField } from './HeatingCostsField'
import { HeatingIncludedField } from './HeatingIncludedField'
import { OtherCostsField } from './OtherCostsField'

import * as styles from '../../RentalPortalListingProfileKeyFactsWidget.module.css'

function RentalPortalListingProfileKeyFactsWidgetFormFields({
  isCloseConfirm,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { actionsProps } = useRentalPortalProfileBlockFormActions({
    isCloseConfirm,
    onCancel,
  })

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody actionsProps={actionsProps} className={styles.formBody}>
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <RentalPortalListingRentPriceField />
        <RentalPortalListingServiceChargeField />
        <HeatingCostsField />
        <HeatingIncludedField />
        <OtherCostsField />
        <RentalPortalListingDepositAmountField />
        <RentalPortalListingDepositTextField />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default RentalPortalListingProfileKeyFactsWidgetFormFields
